module.exports = __webpack_public_path__ + "img/img_brand11.44c90f4f.jpg";